export class DimonaAdmin {
  dimonaId: number;
  periodId: number;
  dimonaType: string;
  dimonaStatus: string;
  startDate: String;
  endDate: String;
  dimonaPeriodId: string;
  reference: string;
}
